export const PRACTICAL_STATUS_FILTER_KEY = 'practicalStatus'
export const PERIOD_FILTER_KEY = 'period'
export const DEFAULT_PERIOD_FILTER = 'LAST_13_MONTHS'
export const TABS_WITH_DEFAULT_PERIOD = ['PENDING', 'PROCESSING', 'CLOSED']

export const DEFAULT_PRACTICAL_STATUS_BY_TAB = {
  PENDING: 'NEW',
  CLOSED: 'EVASED_IN_TIMES'
}

export const getDefaultFiltersForTab = (tab, practicalStatusKey = PRACTICAL_STATUS_FILTER_KEY) => {
  const defaultPracticalStatus = DEFAULT_PRACTICAL_STATUS_BY_TAB[tab]
  const hasDefaultPeriod = TABS_WITH_DEFAULT_PERIOD.includes(tab)

  if (!hasDefaultPeriod && !defaultPracticalStatus) {
    return {}
  }

  return {
    ...(hasDefaultPeriod ? { [PERIOD_FILTER_KEY]: DEFAULT_PERIOD_FILTER } : {}),
    ...(defaultPracticalStatus ? { [practicalStatusKey]: [defaultPracticalStatus] } : {})
  }
}

export const ensureDefaultFiltersForTab = (tab, filters = {}, practicalStatusKey = PRACTICAL_STATUS_FILTER_KEY) => {
  const defaultPracticalStatus = DEFAULT_PRACTICAL_STATUS_BY_TAB[tab]
  const defaultFilters = getDefaultFiltersForTab(tab, practicalStatusKey)
  const normalizedFilters = {
    ...filters,
    ...(defaultFilters[PERIOD_FILTER_KEY] ? { [PERIOD_FILTER_KEY]: filters[PERIOD_FILTER_KEY] || defaultFilters[PERIOD_FILTER_KEY] } : {})
  }

  if (!defaultPracticalStatus) {
    return { ...normalizedFilters }
  }

  const practicalStatuses = Array.isArray(normalizedFilters[practicalStatusKey])
    ? normalizedFilters[practicalStatusKey].filter(Boolean).slice(0, 1)
    : []

  return {
    ...normalizedFilters,
    [practicalStatusKey]: practicalStatuses.length > 0 ? practicalStatuses : [defaultPracticalStatus]
  }
}

export const getActivePracticalStatusForTab = (tab, filters = {}, practicalStatusKey = PRACTICAL_STATUS_FILTER_KEY) => {
  const normalizedFilters = ensureDefaultFiltersForTab(tab, filters, practicalStatusKey)
  return normalizedFilters[practicalStatusKey]?.[0] || ''
}
